import { Component, Input, OnInit, OnDestroy, OnChanges } from '@angular/core';

import { Subscription, TeardownLogic, timer } from 'rxjs';

import { getHours } from 'date-fns';

import { ScreenSizeService } from 'services/screensize/screensize.service';
import { UserInfo } from 'services/user/user.service';

import { SystemRole } from 'modules/shared/roles';

@Component({
    selector: 'app-user-info',
    styleUrls: ['userinfo.component.scss'],
    templateUrl: 'userinfo.component.html',
})
export class UserInfoComponent implements OnInit, OnChanges, OnDestroy {
    private _subrelease: Subscription = new Subscription();
    set subrelease(sub: TeardownLogic) {
        this._subrelease.add(sub);
    }
    private _timerHandle: number | null;

    AllRoles = SystemRole;
    greeting: string;
    username: string;
    role: string;
    SmallDisplay: boolean;
    @Input() user?: UserInfo | null;
    @Input() showName?: boolean;

    constructor(private screenSizeSvc: ScreenSizeService) {
        this.greeting = '';
        this.role = '';
        this.SmallDisplay = false;
        this._timerHandle = null;

        // Set the time of day greeting
        this.SetTimeGreeting();

        // Set up a one hour repeating timer from now to check this again.
        this.subrelease = timer(60 * 60 * 1000).subscribe((_) => {
            this.SetTimeGreeting();
        });

        this.username = (this.user?.FirstName || '') + ' ' + (this.user?.LastName || '');

        this.subrelease = this.screenSizeSvc.ScreenSizeSub.subscribe((size) => {
            this.SmallDisplay = size.IsSmallDisplay;
        });
    }

    ngOnChanges(): void {
        this.username = (this.user?.FirstName || '') + ' ' + (this.user?.LastName || '');
    }

    ngOnDestroy(): void {
        if (this._timerHandle) {
            window.clearTimeout(this._timerHandle);
        }
        this._timerHandle = null;

        this._subrelease.unsubscribe();
    }

    ngOnInit(): void {}

    SetTimeGreeting(): void {
        const self = this;

        const now = new Date();
        const hour = getHours(now);

        if ((hour >= 0 && hour <= 4) || hour >= 18) {
            self.greeting = 'Good evening';
        } else if (hour > 4 && hour < 12) {
            self.greeting = 'Good morning';
        } else if (hour >= 12 && hour < 18) {
            self.greeting = 'Good afternoon';
        }
    }

    SwitchRole(newRole: string): void {
        if (!newRole) {
            return;
        }
    }
}
